export default __webpack_public_path__ + "96c737983976e40e82546f9510e6272e.coffee";